'use strict';

import mainTemplate from './main.html';
import forbiddenTemplate from './forbidden.html';

import Main from './main.ctrl';

function mainRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main', {
      url: '/main',
      template: mainTemplate,
      controller: 'MainController as vm',
      resolve: {
        checkTranslationFilesLoaded: (I18nService) => {
          return I18nService.ensureLoaded();
        }
        // TODO show error message
        // permission: ($q, utils, PermissionsService) => {
        //   return PermissionsService.canIUseMaestro()
        //     ? $q.resolve()
        //     : $q.reject('Route permission check failed: main');
        // }
      }
    })
    .state('main.forbidden', {
      url: '/forbidden',
      template: forbiddenTemplate
    });
}

export default angular
  .module('main.router', [
    Main
  ])
  .config(mainRouter)
  .name;
